import { api } from "./configs/axiosConfigs"

export const priceListCustomersAPI = {
    
    getPriceListCustomers: async (data:any) => {
        const response = await api.get(
            '/priceListCustomer', { params: {...data} }
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    createPriceListCustomer: async (data: any) => {
        const response = await api.post(
            '/priceListCustomer/register', data
        ).then(response => response.data)
        .catch((error) => {
            console.error(error)
            return error.response.data
        })
        return response
    },
    
    editPriceListCustomer: async (idlist: number, data: any) => {
        const response = await api.patch(
            `/priceListCustomer/${idlist}`, data
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },

    deletePriceListCustomer: async (idlist: number) => {
        const response = await api.delete(
            `/priceListCustomer/${idlist}`
        ).then(response => response.data)
        .catch((error) => {
            return error.response.data
        })
        return response
    },
}